import React from 'react';

import Icon from 'bloko/blocks/icon';

const Loading = ({ ...otherProps }) => <Icon initial={Icon.kinds.primary} view={Icon.views.loading} {...otherProps} />;

Loading.kinds = Icon.kinds;
export default Loading;
